import React from "react";
import { DatePicker } from "sulu-admin-bundle/components";

const MatchDayHeader = ({ date, title, handleDateChange }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
      }}
    >
      <h4
        style={{
          width: "70%",
        }}
      >
        {title}
      </h4>
      <div
        style={{
          width: "30%",
        }}
      >
        <DatePicker value={date} onChange={handleDateChange} />
      </div>
    </div>
  );
};

export default MatchDayHeader;
